<template>

<div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Schedule</a>
      <div class="float-right" >

<router-link to="/AddDropRequest">
  <!-- <b-button  title="Help" class="help"  :disabled="!allowButtonDrop">   <b-icon icon="question-square-fill" ></b-icon> Add/Drop</b-button> -->
</router-link></div>

    </h1>
     <!-- <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
     </div> -->

<!-- v-if="isLoading != true" -->
<div class="row"  >
    <div class="col-md-12">
    <div class="panal mt-20">
    <div class="panal-header">Schedule</div> 
    <div class="panal-body">


<div class="table-responsive">
      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}} </div>

       <!-- <div class="alert alert-success"><div class="float-left">Total Credit Hours : <span class="bg-success p-2 white-text rounded mr-4"> {{AllHours.AvailableCredits}}</span> </div><div> Total Registered Credits : <span class="bg-success p-2 white-text rounded mr-4">{{AllHours.RegisteredCredits}}  </span></div></div>  -->
 <table class="table table-hover table-bordered">
    <thead class="thead-light">
        <tr>
        <th scope="col" >Course Name</th>
        <th scope="col" >Course Code</th>
       
        <th scope="col" >Credit Hours</th>
        
        <th scope="col" >Action</th>
        
        </tr>
    </thead>
    <tbody >
    
        <tr v-if="empty"><td colspan="12" class="text-danger font-weight-bold"> No Data </td></tr>

        <tr v-else v-for="(item,index) in scheduleData" v-bind:key="index">
        <td> {{item.CourseName}} </td>
        <td> {{item.CourseCode}} </td>
           
        <td> {{item.CreditHours}} </td>
        
        <td> 
        <button  class="btn btn-info mr-2"  @click="showDetails(item)"> details</button> 
        <!-- v-if="allowUpdateDrop && AllHours.AvailableCredits !== AllHours.RegisteredCredits"  -->
          <button  class="btn btn-primary mr-2  " @click="UpdateRegesteredCourses(item.CourseID)"> update</button>
           <!-- AllHours.RegisteredCredits < AllHours.AvailableCredits -->
          <button  class="btn btn-danger mr-2"  @click="DropRegesteredCourses(item.CourseID)"> Drop</button>
<!-- v-if="allowUpdateDrop && AllHours.AvailableCredits !== AllHours.RegisteredCredits" -->
        
        <!-- <button  class="btn btn-warning btn-block">Drop</button> -->
        </td>   
        
        </tr>

        
    </tbody>
   </table>
    


</div>


<div class="float-right"> 
 

  
   
<router-link to="/Calendar" tag="button" class="btn btn-primary btn-block">Back</router-link></div>
<div class="clearfix"></div>

 
<!-- {{ table }} -->

</div>
</div>
</div>
</div>

<div class="row"  >
    <div class="col-md-12">
    <div class="panal mt-20">
    <div class="panal-header">Time Table</div> 
    <div class="panal-body table-responsive">


 <div class="header">
            <h1 class="text-center"> Schedule</h1>
           
        </div>

        <div class="table-container">
             <table class="table table-hover table-bordered" id="scheduleTable">
                <thead>
                    <tr>
                        <th>Days</th>
                        <th>Time</th>
                        <th>Course Code</th>
                        <th>Course Name</th>
                        <th>Location</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(items, day) in groupedData">
                        <!-- First row with weekday -->
                        <tr :key="day + '-first'" :class="items[0].TypeNameEN.toLowerCase()">
                            <td class="day-header" :rowspan="items.length">{{ day }}</td>
                            <td class="time-cell">{{ items[0].StartTime }} - {{ items[0].EndTime }}</td>
                            <td class="course-code">{{ items[0].CourseCode }}</td>
                            <td class="course-name">{{ items[0].CourseNameEN }}</td>
                            <td class="location">{{ items[0].RoomName }}</td>
                            <td><span class="type-badge" :class="'type-' + items[0].TypeNameEN.toLowerCase()">{{ items[0].TypeNameEN }}</span></td>
                        </tr>
                        <!-- Rest of the rows for this day -->
                        <tr v-for="(item, idx) in items.slice(1)" :key="day + '-' + idx" :class="item.TypeNameEN.toLowerCase()">
                            <td class="time-cell">{{ item.StartTime }} - {{ item.EndTime }}</td>
                            <td class="course-code">{{ item.CourseCode }}</td>
                            <td class="course-name">{{ item.CourseNameEN }}</td>
                            <td class="location">{{ item.RoomName }}</td>
                            <td><span class="type-badge" :class="'type-' + item.TypeNameEN.toLowerCase()">{{ item.TypeNameEN }}</span></td>
                        </tr>
                    </template>
                    <tr v-if="Object.keys(groupedData).length === 0">
                        <td colspan="6" class="no-classes">No classes scheduled</td>
                    </tr>
                </tbody>
            </table>
        </div>

<div class="float-right ">   <b-button variant="primary" @click="printTable">
     Print Table
    </b-button></div>

     <!-- Export button -->
    <button class="btn btn-primary mt-3" @click="exportPDF">
      Export Schedule to PDF
    </button>

      </div>
      </div>
      </div>
</div>


<b-modal 
      id="modal-lg"
      size="lg"
      ok-only
      :title="details.CourseNameEN"
    >
      <div class="row">
        <div class="col-md-3 col-sm-12 mt-2">
          <div class="profileData">Course Name</div>
        </div>
        <div class="col-md-9 col-sm-12 mt-2">
          <div class="profileData2">{{ details.CourseName }}</div>
        </div>
        <div class="clearfix"></div>

        <div class="col-md-3 col-sm-12 mt-2">
          <div class="profileData">Course Code</div>
        </div>
        <div class="col-md-9 col-sm-12 mt-2">
          <div class="profileData2">{{ details.CourseCode }}</div>
        </div>
        <div class="clearfix"></div>

        <div class="col-md-3 col-sm-12 mt-2">
          <div class="profileData">Credit Hours</div>
        </div>
        <div class="col-md-9 col-sm-12 mt-2">
          <div class="profileData2">{{ details.CreditHours }}</div>
        </div>
        <div class="clearfix"></div>
        

      </div>
      <div class="panel  mt-2" v-for="(item,i) in details.SectionsList" :key="i">
          <div class="panel panel-primary">
              <div class="panel-headder">Type name :  {{ item.TypeNameEN }}</div>
              <div class="panel-body">
                                     <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                        <tr>
                        <th scope="col" >WeekDay</th>
                        <th scope="col" >StartTime</th>
                    
                        <th scope="col" >EndTime</th>
                        
                        <th scope="col" >BuildingName</th>
                        
                        <th scope="col" >RoomName</th>
                        <th scope="col" >professor Name</th>
                        
                        </tr>
                        </thead>
                    <tbody >
                           

        <tr  v-for="time in item.ScheduleLst" v-bind:key="time.Serial">
        <td> {{time.WeekDay}} </td>
        <td> {{time.StartTime}} </td>
           
        <td> {{time.EndTime}} </td>
        <td v-if="time.IsOnline === true"> {{time.BuildingName == null ? "Online" : time.BuildingName }} </td>
        <td v-else> {{time.BuildingName == null ? "--" : time.BuildingName }}  </td>
        <td> {{time.IsOnline == true ?  time.RoomName  == null ? 'Online'  : time.RoomName : time.RoomName}} </td>
        <td> {{time.ProfessorLst.map(y=> y.Name).join('-')}} </td>
        
        
          
        
        </tr>

        
    </tbody>
   </table>
              </div>
          </div>
          
          
        </div>
        <div class="clearfix"></div>
    </b-modal>


</div>
</template>
<script>
import SelectSubjectServices from '../../services/academic/SelectSubject.services';
import SelectSubject from "../../services/academic/SelectSubject.services";
    import SchedualeData from '../../services/student/studentDataServices';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

    export default {
        name: 'Schedule',
        data(){
            return {
                scheduleData: [], 
                 message:'',
                isLoading : true, 
                empty:false,
                successful : '',
                details:{},
                allowUpdateDrop:false,
                allowButtonDrop:false,
                loading: true,
                AllHours:'',
                tableData: [], // This will store the formatted data for export
            }        
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },
    groupedData() {
      // 🔹 Remove duplicates
      const unique = [];
      const seen = new Set();

      this.tableData.forEach(item => {
        const key = `${item.WeekDay}-${item.StartTime}-${item.EndTime}-${item.CourseCode}`;
        if (!seen.has(key)) {
          seen.add(key);
          unique.push(item);
        }
      });

      // 🔹 Group by weekday
      const grouped = unique.reduce((acc, item) => {
        if (!acc[item.WeekDay]) acc[item.WeekDay] = [];
        acc[item.WeekDay].push(item);
        return acc;
      }, {});

      // 🔹 Sort times inside each weekday
      Object.keys(grouped).forEach(day => {
        grouped[day].sort((a, b) => a.StartTime.localeCompare(b.StartTime));
      });

      return grouped;
    }
    
       },  mounted(){

         // Simulate data loading
                setTimeout(() => {
                    // This would typically come from an API
                    console.log("Data loaded successfully");
                }, 500);
        //    this.currenUser.StudentID  // 25096 , 566
          this.GetSchadule()
          this.GetRegistrationPeriodSelect(this.currenUser.StudentID)

 SelectSubject.GetRegistrationCredits(this.currenUser.StudentID, 3).then(Response =>{
             
               this.AllHours = Response.data
                this.empty =false
            
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })

            SelectSubject.GetStudentSchedule(this.currenUser.StudentID).then(Response =>{
             
               this.tableData = Response.data
                this.empty =false
            
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),

               SelectSubject.RegistrationRequest_GetRequestPeriodSelect().then(res=>{
              console.log(res.data)

              this.allowButtonDrop = res.data[0].IsActive ;
             
              this.loading = false
            }).catch(()=>{
              this.loading = false
            })
   

       },methods:{
   printTable() {
      const printContents = document.getElementById("scheduleTable").outerHTML;
      const newWindow = window.open("", "", "width=900,height=650");
      newWindow.document.write(`
        <html>
          <head>
            <title>Schedule</title>
            <style>
              table { width:100%; border-collapse: collapse; }
              th, td { border: 1px solid #333; padding: 8px; text-align: center; }
              th { background: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">Schedule</h2>
            ${printContents}
          </body>
        </html>
      `);
      newWindow.document.close();
      newWindow.print();
    },
    
 
 exportPDF() {
      const doc = new jsPDF("l", "pt", "a4"); // landscape, points, A4 size

      doc.text("Class Schedule", 40, 30);

      // Convert table by ID
      autoTable(doc, {
        html: "#scheduleTable",
        startY: 50,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 5,
        },
        headStyles: {
          fillColor: [52, 73, 94], // dark blue-gray
          textColor: [255, 255, 255],
        },
      });

      doc.save("schedule.pdf");
    },


           DropRegesteredCourses(CourseSerial){
            let confirm = window.confirm('Are you Sure you want to Drop this course')
            if(confirm){
              // eslint-disable-next-line no-unused-vars
              SelectSubjectServices.CheckRegisteredCoRequisite(this.currenUser.StudentID, CourseSerial).then(res=>{
              SelectSubjectServices.DropRegesterdCourse(this.currenUser.StudentID ,CourseSerial , 3 ).then(data=>{
                  
                   this.message = data.data
                  this.successful = true
                  this.GetSchadule();
              }, error => {
             this.empty = true
                 // eslint-disable-next-line no-console
                 //console.log(error.response.status)
                this.successful = false
             this.message =
               (error.response && error.response.data && error.response.data.Message) ||
               error.message ||
               error.toString();
               
               if(error.response.status == 404) this.message =''
            
           })
         
              },errorMessage=>{
        let confirm = window.confirm(errorMessage.response.data.Message)
              if (confirm){
                SelectSubjectServices.DropRegesterdCourse(this.currenUser.StudentID ,CourseSerial , 3 ).then(data=>{
                  
                  this.message = data.data
                 this.successful = true
                 this.GetSchadule();
             }, error => {
            this.empty = true
                // eslint-disable-next-line no-console
                //console.log(error.response.status)
               this.successful = false
            this.message =
              (error.response && error.response.data && error.response.data.Message) ||
              error.message ||
              error.toString();
              
              if(error.response.status == 404) this.message =''
           
          })
              }
            }
              )

            }
           },
           UpdateRegesteredCourses(CourseSerial){
               SelectSubjectServices.UpdateRegesterdCourse(this.currenUser.StudentID ,CourseSerial , 3 ).then(data=>{
                   
                   this.message = data.data
                   this.successful = true
                   this.GetSchadule();
               }, error => {
              this.empty = true
                  // eslint-disable-next-line no-console
                  //console.log(error.response.status)
                 this.successful = false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })
           },
           GetSchadule(){
                SchedualeData.getStudentSchedualeNew(this.currenUser.StudentID).then(Response =>{
               this.isLoading = false ;
               this.scheduleData = Response.data
               this.empty =false
               // eslint-disable-next-line no-console
               // console.log('Scheduale => ', Response.data)
           }, error => {
              this.empty = true
                  // eslint-disable-next-line no-console
                  //console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
           },
           showDetails(item){
               this.details = item 
               this.$bvModal.show('modal-lg')
           },
         async  GetRegistrationPeriodSelect(){
            SelectSubjectServices.GetRegistrationPeriodSelect(this.currenUser.StudentID).then(res=>{
              console.log(res.data)
              this.allowUpdateDrop = res.data[0].IsActive
            })
           }
       },
       

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.help {
    color: #fff;
    background-color: #ff8600 !important;
    /* padding: 2px 16px; */
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.profileData {
  border: 1px dotted #646464;
  color: #285475;
  padding: 3px 10px;
  font-weight: 700;
}

.profileData2 {
  border: 1px dotted #646464;
  color: #ff8600;
  padding: 3px 10px;
  font-weight: 700;
}
.clearfix {
  clear: both;
  display: table;
}
.line1 {
  border-top: 1px dotted #285475;
  border-bottom: 1px dotted #285475;
  height: 10px;

  float: left;
  margin: 57px 20px;
}
@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}


</style>
